<script lang="ts">
	import ControlOnOffAddon from '../Controls/Single/ControlOnOffAddon.svelte';

	export let device, status, outputs;
	export let useV2Components = false;

	let className = '';
	let isWide = true;

	//Display 2 switch outputs side by side
	$: {
		if (outputs.length == 2) {
			className = 'd-flex';
			isWide = false;
		} else {
			className = 'flex-direction-column';
			isWide = true;
		}
	}
</script>

<div class="{className} gap-s">
	{#each outputs as output, index}
		<div class="flex-1 mt-s">
			<ControlOnOffAddon
				{useV2Components}
				isInSlot
				{isWide}
				{device}
				{status}
				component={output.sensor.component}
				controlName={output.sensor.name}
			/>
		</div>
	{/each}
</div>
